import { API, graphqlOperation } from "aws-amplify";
import { areaByActiveBySortKey } from "../../../graphql/reloadyard/custom-queries";

import { logError } from "../../../utils/appUtils";
import { assetTypeByActiveByName } from "../../../graphql/queries";

export const fetchAreas = async (setAreas, notify) => {
  try {
    const searchQuery = {
      reloadYardId: window.appUser?.reloadYardId,
      activeSortKey: {
        beginsWith: {
          active: "true",
        },
      },
    };
    debugger;
    const results = await API.graphql(
      graphqlOperation(areaByActiveBySortKey, searchQuery)
    );

    const fetchedAreas = results.data.areaByActiveBySortKey.items;
    // window.appUser.reloadYard.areas.items = fetchedAreas;

    // Return the list of areas
    setAreas(fetchedAreas);
  } catch (error) {
    logError("reloadYard:ReloadYardUtils:fetchAreas", error, notify);
  }
};

export const fetchAssetTypes = async (setAssetTypes, notify) => {
  try {
    const searchQuery = {
      reloadYardId: window.appUser?.reloadYardId,
      activeName: {
        beginsWith: {
          active: "true",
        },
      },
    };
    const results = await API.graphql(
      graphqlOperation(assetTypeByActiveByName, searchQuery)
    );

    const fetchedAssets = results.data.assetTypeByActiveByName.items;
    // window.appUser.reloadYard.areas.items = fetchedAssets;

    // Return the list of assetTypes
    setAssetTypes(fetchedAssets);
  } catch (error) {
    logError("reloadYard:ReloadYardUtils:fetchAssetTypes", error, notify);
  }
};
